module.exports = __webpack_public_path__ + "img/drop-image.96f9fad9.png";